import React from "react";
import { CustomOutlinedDisabledTextField } from "../../../../../partials/content/Forms";
import { Card } from "react-bootstrap";
const CustomerBasicInfo = ({ customer }) => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <Card>
            <Card.Header>
              <i className="fas fa-th-large"></i>
              <span>
                <strong>Customer Basic Info</strong>
              </span>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-sm-4 col-md-4 col-lg-4">
                  <CustomOutlinedDisabledTextField
                    label="Customer Name"
                    value={customer.customerName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Customer Group"
                    value={customer.customerGroup.groupName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Contact Name"
                    value={customer.contactName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Position"
                    value={customer.position}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Website"
                    value={customer.website}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Taxpayer Identification Number"
                    value={customer.taxpayerID}
                  />
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                  <CustomOutlinedDisabledTextField
                    label="Phone Number"
                    value={customer.contactPhone}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Email"
                    value={customer.contactEmail}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Industry Type"
                    value={customer.industryType.industryTypeName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Business Size"
                    value={customer.businessSize.businessSizeName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Source"
                    value={customer.source.sourceName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Receivable Account"
                    value={customer.receivableAccountName}
                  />
                </div>
                <div className="col-sm-4 col-md-4 col-lg-4">
                  <CustomOutlinedDisabledTextField
                    label="Address"
                    value={customer.address}
                  />
                  <CustomOutlinedDisabledTextField
                    label="City"
                    value={customer.city}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Province / State"
                    value={customer.province}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Country"
                    value={customer.countryName}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Postal Code"
                    value={customer.postalCode}
                  />
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomerBasicInfo;
